import { Typography } from '@mui/material';
import { TALKIATRY_PHONE_NUMBER_DISPLAY } from '../../../helpers/const';
import { updateMeta } from '../../../redux/meta';
import { AppDispatch } from '../../../redux/types';
import { AssessmentButtons, AssessmentCard, AssessmentHeader } from '../shared';

type PropTypes = {
  dispatch: AppDispatch;
};

const OtherInsurancePlan = ({ dispatch }: PropTypes) => (
  <>
    <AssessmentHeader title="Don't see your plan?" />
    <AssessmentCard>
      <Typography paragraph>
        We partner with your insurer, but we might not accept your specific
        plan. Just upload a picture of your insurance card at the end of the
        assessment and our team will email you to confirm.
      </Typography>
      <Typography>
        Questions? Give us a call at {TALKIATRY_PHONE_NUMBER_DISPLAY}.
      </Typography>
    </AssessmentCard>
    <AssessmentButtons
      primary={{
        children: 'Continue',
        onClick: () => dispatch(updateMeta()),
      }}
    />
  </>
);

export default OtherInsurancePlan;
